import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import numeral from 'numeral';
import PageHeader from '../Header';
import SearchBar from '../SearchBar';
import Profile from '../Profile';
import MapMain from '../MapMain';
import Setting from '../Setting';
import HeaderCombine from '../HeaderCombine';
import Logout from './Logout';
import MultipliersDropdown from './MultipliersDropdown';
import EconomicModelTable from './EconomicModelTable';
import { Layout,  Row, Col } from 'antd';
import MultipliersInput from './MultipliersInput';
import {startSetMultiplier} from '../../actions/globalState';
import {addIndirectImpact, getSumObjectByColumn} from '../../utils/utils';
const { Header, Footer, Sider, Content } = Layout;


export class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: 1, sum: 0, total: 0 };
  }

  onInputChange = (value) => {
    this.setState({ value });
  }

  multipliersChange = (value) => {
    this.props.startSetMultiplier(value);
  } 

  onEconomicOverviewChange = (text) => {
    this.props.startSetOverviewChange(text);
  }
  render () {
    
    const economicModel = this.props.data.economicModel
    //console.log('economicModel', economicModel)
    const tableData = addIndirectImpact(economicModel.table, this.state.value);
    const sum = getSumObjectByColumn(tableData, 'indirect')
    const total = numeral(sum).value() + numeral(this.state.value).value()
    //console.log('table data', tableData, 'sumObject', sum, 'total', total, 'this.state.value', this.state.value)
    return (
      <Layout>
        <Header>
          <HeaderCombine showProfile={true}/>
        </Header>
        <Logout />
        <Layout>
            <Sider width={450} style={{ background: '#fff' }} className="economic-model-sider">
              <h1>Economic Model</h1>
              <p>Explanation or instruction</p>
                <div className="economic-model-box">
                  <h4>Select industry</h4>
                  <MultipliersDropdown 
                  multiplier={economicModel.multiplier}
                  multipliers={economicModel.multipliers}
                  multipliersChange={(value) => this.multipliersChange(value)}/>
                  <h4>Investment amount <br />(direct investment into industry)</h4>
                  <MultipliersInput style={{ width: 120 }} value={this.state.value} onChange={this.onInputChange} />

                </div>
            </Sider>
            <Content>
              <div className="economic-model-summary">
                <div className="economic-model-box">
                  <h4>Sum of indirect impacts </h4>
                  <h3>{numeral(sum).format('$0,0.00')}</h3>
                </div>
                <div className="economic-model-box">
                  <h4>Total impacts into industry </h4>
                  <h3>{numeral(total).format('$0,0.00')}</h3>
                </div>
              </div>
              <EconomicModelTable data={tableData} />
              
              
        </Content>
        </Layout>

    </Layout>
    )
  }


};

const mapStateToProps = (state) => ({
  data: state.globalState
});

const mapDispatchToProps = (dispatch) => ({
  startSetMultiplier: (text) => dispatch(startSetMultiplier(text)),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);




// WEBPACK FOOTER //
// ./src/components/economicModel/Dashboard.js